import { contextFactory } from '../../services/contextFactory';
import { IExperimentsContext, IExperimentsProviderProps } from './interfaces';
import { Challenges } from '../../editor/types/Experiments';
import { isDisabled, isEnabled } from '../../services/experiments';
import React from 'react';

const { context, ContextProvider, withConsumer } = contextFactory<
  IExperimentsContext,
  IExperimentsProviderProps
>({
  defaultValues: {
    experiments: {} as any,
    disabled: () => true,
    enabled: () => false,
  },
  displayName: 'ExperimentsProvider',
  propsToContext(props): IExperimentsContext {
    return {
      experiments: props.experiments,
      enabled(experiment: Challenges): boolean {
        return isEnabled(props.experiments?.[experiment]);
      },
      disabled(experiment: Challenges): boolean {
        return isDisabled(props.experiments?.[experiment]);
      },
    };
  },
});

export const ExperimentsContext = context;
export const ExperimentsProvider = ContextProvider;
export const withExperiments = withConsumer;

export const useExperiments = () => React.useContext(ExperimentsContext);
